import { AppendIfPrefixExists } from "modules/sitePaths";

export function getCheckoutEntryPath(): string {
  return AppendIfPrefixExists("/checkout");
}
